import { IEditStatePayload, IStateCreate, IStateListSearch, IStateSearch } from "../../../../types/master/stateInterface";
import api from "../../../../lib/api";

export const getStateByIdApi = async (data: IStateSearch) => {
  return await api.get(`state/${data.state}`, {
    signal: data.signal,
  });
};

export const createStateApi = async (data: IStateCreate) => {
  return await api.post(`/state`, data);
};

export const getStateListApi = async (data: IStateListSearch) => {
  return await api.get(`/state/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const deleteStateApi = async (id: number) => {
  return await api.delete(`/state/${id}`);
};

export const getStateDataByIdApi = async (id: number | string) => {
  return await api.get(`/state/${id}`)
}

export const editStateDataByIdApi = async (payload: IEditStatePayload) => {
  return await api.put(`/state/${payload.id}`, payload.data);
};